
import Vue from 'vue';
import PrimeVue from 'primevue/config';

import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

import CookieBar from './components/layout/CookieBar.vue';

Vue.use(PrimeVue);

Vue.component('cookie-bar', CookieBar);

new Vue({
    el: '#app',
});

